import { createContext } from "react"

import type { PredictionContextType } from "./Interfaces"

export const Context = createContext<PredictionContextType>({
  step: 0,
  type: null,
  setType: undefined,
  setStep: undefined,
  sendPredictionMutation: undefined,
  isSendingBulkRequests: false,
  setIsSendingBulkRequests: undefined,
  sendWorkFlowPredictionTestMutation: undefined,
  sendModelPredictionTestMutation: undefined,
  isTestModal: false,
})
